<template>
  <div
    class="noThumbnailImage"
    :class="{ 'noThumbnailImage--absolute': absolute }"
    :style="{ width, height, backgroundColor: color }"
    @click="handleClick"
    @dblclick="handleDoubleClick"
  >
    <template v-if="tooltip && !!caption">
      <v-tooltip top :nudge-bottom="3" content-class="noThumbnailImage-tooltip">
        <template v-slot:activator="{ on, attrs }">
          <img
            v-bind="attrs"
            src="@/assets/img/ico_video_off.svg"
            alt=""
            v-on="on"
          />
        </template>
        <h2>{{ noBrCaption }}</h2>
      </v-tooltip>
    </template>
    <template v-if="loading">
      <div :style="{ width, height }" class="noThumbnailImage_skeleton"></div>
    </template>
    <template v-else-if="!tooltip">
      <img src="@/assets/img/ico_video_off.svg" alt="" />
      <h2 v-if="!!caption" v-html="caption"></h2>
    </template>
    <slot />
    <section
      v-if="theme === 'dark-bg'"
      class="noThumbnailImage--dark-bg"
    ></section>
  </div>
</template>

<script>
export default {
  name: 'NoImage',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.5)',
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  computed: {
    noBrCaption() {
      return this.caption ? this.caption.split('<br>').join('') : '';
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    },
    handleDoubleClick() {
      this.$emit('onDoubleClick');
    },
  },
};
</script>

<style lang="scss">
.noThumbnailImage {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eeeeee;
  &--dark-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #4b4b4b;
  }
  img {
    width: 32px;
    height: 32px;
    z-index: 1;
  }
  &--absolute {
    position: absolute;
    top: 0;
  }
  & > h2 {
    margin-top: 5px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #f8f8fc;
    z-index: 1;
  }
  &-tooltip {
    &.v-tooltip__content {
      width: 183px;
      height: 54px;
      padding: 1px 6px 2px;
      border-radius: 6px;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
      opacity: 0;
      background-color: #4b4b4b;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      &:after,
      &:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #4b4b4b;
        border-width: 5px;
        margin-left: -5px;
      }
      &:before {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #4b4b4b;
        border-width: 6px;
        margin-left: -6px;
      }
      &.menuable__content__active {
        opacity: 1 !important;
      }
    }
  }

  // THE LOADING EFFECT
  &_skeleton {
    background-color: #e2e5e7;
    // The shine that's going to move across the skeleton:
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0),
      rgba(#fff, 0.5),
      rgba(#fff, 0)
    );
    background-size: 40px 100%; // width of the shine
    background-repeat: no-repeat; // No need to repeat the shine effect
    background-position: left -40px top 0; // Place shine on the left side, with offset on the left based on the width of the shine - see background-size
    animation: shine 1s ease infinite; // increase animation time to see effect in 'slow-mo'
  }

  @keyframes shine {
    to {
      // Move shine from left to right, with offset on the right based on the width of the shine - see background-size
      background-position: right -40px top 0;
    }
  }
}
</style>
